const PorqueElegirnos = () => {
  return (
    <div className="card p-4 b-radius-10">
                  <h2 style={{ color: "#05294F" }}><strong>¿Por qué elegirnos?</strong></h2>
                  <hr />
                  <div className="contenido">
                    
                      <div>
                        <p><br /></p>
                        <p style={{ textAlign: "center" }}>
                          <img
                            style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
                            className="img-fluid"
                            alt="imagen"
                            src="https://sitioinstituionalqa.blob.core.windows.net/strapi-qa/strapi-qa/assets/privilege_a546a71de1.png"
                          />
                        </p>
                        <p><br /></p>
                        <p>
                          En el Hospital Británico trabajamos día a día para fortalecer el acompañamiento a nuestros pacientes durante toda su estancia en la institución. Por ello, contamos con <strong>Privilege HB</strong>, una oficina dedicada a brindar atención personalizada, con calidad humana y eficiencia en cada etapa del proceso asistencial.
                        </p>
                        <p>
                          Desde el primer contacto hasta el regreso al hogar, <strong>Privilege HB</strong> se ocupa de agilizar el recorrido del paciente, asegurando su bienestar, la mejora continua y la satisfacción con la experiencia vivida.
                        </p>
                        <p>
                          Comprometidos con brindar una <em>“experiencia integral con calidez”</em>, nos enfocamos en generar vínculos positivos, escuchando con atención y comprendiendo las necesidades de cada persona. Nuestro principal objetivo es que quienes nos eligen se sientan tranquilos, valorados y plenamente acompañados en todo momento.
                        </p>
                      </div>
                    
                  </div>
                </div>
  );
};

export default PorqueElegirnos;